import React, { FC, useState } from 'react';
import { MdHistory } from 'react-icons/md';
import { IconButton, Badge, Box } from '@chakra-ui/react';

import { Dialog } from '@app/components/common';

import View from './view';

interface ViewModalProps {
  title: string;
  id: string;
}

const ViewModal: FC<ViewModalProps> = (props) => {
  const { title, id } = props;
  const [open, setOpen] = useState(false);

  return (
    <Box position='relative'>
      <IconButton onClick={() => setOpen(true)} aria-label="view">
        <MdHistory />
      </IconButton>
      {/* {items?.length && <Badge 
        position='absolute'
        ml={-2}
        mt={6}
        zIndex={1}
        variant='solid'
        colorScheme="brand"
      >{items?.length}</Badge>} */}
      <Dialog 
        open={open} 
        width="max"
        onClose={() => setOpen(false)} title={`История транзакций (ID ХО: ${id})`}
      >
        <View title={title} id={id} />
      </Dialog>
    </Box>
  );
};

export default ViewModal;
